const OverlayManagerSystem = {
  namespaced: true,

  state: {
    messages: [],
  },

  actions:{
    addMessage({ commit }, { text, color }) {
      const id = Date.now();
      commit('toAddNewItem', { id, text, color });
      setTimeout(() => commit('toRemoveItem', id), 5000);
    }
  },

  mutations: {
    toAddNewItem(state, { id, text, color }) {
      state.messages.push({ id, text, color });
    },

    toRemoveItem(state, id) {
      state.messages = state.messages.filter(item => item.id !== id);
    }
  },

  getters:{

  }
}

export default OverlayManagerSystem;
